// @flow
export const AUTOCOMPLETE_THEME_API = {
  autocompleteWrapper: '',
  autocompleteContent: '',
  selectedWords: '',
  selectedWordBox: '',
  selectedWordValue: '',
  selectedWordRemoveButton: '',
  hasSelectedWords: '',
  opened: '',
  errored: '',
  requiredWordsInfo: '',
};
